<template>
  <div>
    <div class="page-wrapper">
      <section class="topbar-one topbar-one__inner-page">
        <div class="container"></div>
      </section>
      <!-- 导航栏 -->

      <nav :class="['main-nav-one', 'main-nav-one__inner-page', {'stricky': showScrollTop}]">
        <div class="container">
          <div class="inner-container">
            <div class="logo-box">
              <router-link to="/" class="main-nav-one__logo">
                <img
                  src="@/assets/images/index/logo.png"
                  class="main-nav-one__main-logo"
                  width="300"
                  alt="网站Logo"
                />
                <img
                  src="@/assets/images/index/logo.png"
                  class="main-nav-one__mobile-logo"
                  alt="移动端Logo"
                />
              </router-link>
            </div>

            <div class="main-nav__main-navigation">
              <MenuItem />
            </div>

            <div class="main-nav__right">
              <a
                href="#"
                class="side-menu__toggler"
                @click.prevent="toggleSideMenu"
              >
                <i class="fa fa-bars"></i>
              </a>
              <a href="tel:400-889-0919" class="main-nav-one__cta" style="text-align: left">
                <i class="oberlin-icon-whatsapp"></i>
                <span>联系电话</span>
                <b>400-889-0919</b>
              </a>
            </div>
          </div>
        </div>
      </nav>
      <section>
        <el-carousel
          indicator-position="outside"
          :interval="4000"
          height="700px"
        >
          <el-carousel-item
            v-for="(item, index) in carouselimages"
            :key="index"
          >
            <img
              :src="item"
              alt="Carousel Image"
              style="width: 100%; height: 100%; object-fit: cover"
            />
          </el-carousel-item>
        </el-carousel>
      </section>
      <!-- /.slider-one__wrapper -->

      <section class="service-one service-one__home-one">
        <div class="container">
          <div class="block-title text-center">
            <p>我们的服务</p>
            <h3>
              每个人都值得我们 <br />
              最好的服务
            </h3>
          </div>
          <!-- /.block-title -->
          <div class="service-one__grid" style="display: flex; flex-wrap: wrap;justify-content: space-evenly;
    flex-direction: row;
    align-items: center;">
            
            <div class="item">
              <div class="service-one__single">
                <div class="service-one__content">
                  <div class="service-one__icon">
                    <i class="oberlin-icon-disability"></i>
                  </div>
                  <!-- /.service-one__icon -->
                  <h3><a> 无障碍适老设施</a></h3>
                  <p>
                    按照国家标准设置 全程无障碍生活 多重安全保障
                  </p>
                  <!-- <a class="service-one__link"
                    ><i class="far fa-long-arrow-alt-right"></i
                  ></a> -->
                  <!-- /.service-one__link -->
                </div>
                <!-- /.service-one__content -->
              </div>
              <!-- /.service-one__single -->
            </div>
            <!-- /.col-lg-4 -->
            <div class="item">
              <div class="service-one__single">
                <div class="service-one__content">
                  <div class="service-one__icon">
                    <i class="oberlin-icon-disability"></i>
                  </div>
                  <!-- /.service-one__icon -->
                  <h3><a> 专业化医养团队</a></h3>
                  <p>
                    经验丰富的护理人员 经验丰富的医疗团队
                    独居特色的照护师培养制度
                  </p>
                  <!-- <a class="service-one__link"
                    ><i class="far fa-long-arrow-alt-right"></i
                  ></a> -->
                  <!-- /.service-one__link -->
                </div>
                <!-- /.service-one__content -->
              </div>
              <!-- /.service-one__single -->
            </div>

            <div class="item">
              <div class="service-one__single">
                <div class="service-one__content">
                  <div class="service-one__icon">
                    <i class="oberlin-icon-stethoscope"></i>
                  </div>
                  <!-- /.service-one__icon -->
                  <h3><a>针对性营养餐食</a></h3>
                  <p>
                    从实践中不断总结经验 取得营养和口味的平衡 兼顾南北饮食的差异
                  </p>
                  <!-- <a class="service-one__link"
                    ><i class="far fa-long-arrow-alt-right"></i
                  ></a> -->
                  <!-- /.service-one__link -->
                </div>
                <!-- /.service-one__content -->
              </div>
              <!-- /.service-one__single -->
            </div>
            <!-- /.col-lg-4 -->
            <div class="item">
              <div class="service-one__single">
                <div class="service-one__content">
                  <div class="service-one__icon">
                    <i class="oberlin-icon-disability"></i>
                  </div>
                  <!-- /.service-one__icon -->
                  <h3><a>标准化企业管理</a></h3>
                  <p>
                    ISO9001质量体系保障 养老服务质量的自我提升
                    企业管理质量的闭环控制
                  </p>
                  <!-- <a class="service-one__link"
                    ><i class="far fa-long-arrow-alt-right"></i
                  ></a> -->
                  <!-- /.service-one__link -->
                </div>
                <!-- /.service-one__content -->
              </div>
              <!-- /.service-one__single -->
            </div>
            <!-- /.col-lg-4 -->
          </div>
          <!-- /.row -->
        </div>
        <!-- /.container -->
      </section>
      <!-- /.service-one -->

      <section class="about-three">
        <div class="container">
          <div class="row">
            <div class="col-lg-6">
              <div class="about-three__content">
                <div class="block-title">
                  <p class="has-line">关于我们</p>
                  <!-- /.has-line -->
                  <h3>
                    爱的最佳家庭护理中心 <br />
                    with Love
                  </h3>
                </div>
                <!-- /.block-title -->
                <p>"区域性养老服务体系"提供商 拥有"四位一体"养老服务能力</p>
                <div class="row">
                  <div class="col-xl-6">
                    <ul class="blog-details__list list-unstyled">
                      <li>
                        <i class="fa fa-check-circle"></i>
                        全国养老服务先进单位
                      </li>
                      <li>
                        <i class="fa fa-check-circle"></i>
                        五星级养老机构
                      </li>
                    </ul>
                    <!-- /.blog-details__list list-unstyled -->
                  </div>
                  <!-- /.col-md-6 -->
                  <div class="col-xl-6">
                    <ul class="blog-details__list list-unstyled">
                      <li>
                        <i class="fa fa-check-circle"></i>
                        现场医生服务
                      </li>
                      <li>
                        <i class="fa fa-check-circle"></i>
                        基本医疗保险定点医疗机构
                      </li>
                    </ul>
                    <!-- /.blog-details__list list-unstyled -->
                  </div>
                  <!-- /.col-md-6 -->
                  <div>
                    <video width="500" height="350" controls>
                      <source :src="videos" type="video/mp4" />
                    </video>
                  </div>
                  <!-- <img src="assets/images/resources/about-1-1-sign.png" alt=""> -->
                </div>
                <!-- /.row -->
              </div>
              <!-- /.about-three__content -->
            </div>
            <!-- /.col-lg-6 -->
            <div
              id="carouselExample"
              class="carousel slide"
              data-ride="carousel"
            >
              <ol class="carousel-indicators">
                <li
                  data-target="#carouselExample"
                  data-slide-to="0"
                  class="active"
                ></li>
                <li data-target="#carouselExample" data-slide-to="1"></li>
                <li data-target="#carouselExample" data-slide-to="2"></li>
              </ol>
              <div class="carousel-inner">
                <div
                  class="carousel-item"
                  v-for="(item, index) in rowList"
                  :key="index"
                  :class="{ active: index === 0 }"
                >
                  <img
                    :src="item"
                    class="d-block w-100"
                    :alt="`Slide ${index + 1}`"
                    style="width: 500px; height: 700px"
                  />
                </div>
              </div>
              <a
                class="carousel-control-prev"
                href="#carouselExample"
                role="button"
                data-slide="prev"
              >
                <span
                  class="carousel-control-prev-icon"
                  aria-hidden="true"
                ></span>
                <span class="sr-only">Previous</span>
              </a>
              <a
                class="carousel-control-next"
                href="#carouselExample"
                role="button"
                data-slide="next"
              >
                <span
                  class="carousel-control-next-icon"
                  aria-hidden="true"
                ></span>
                <span class="sr-only">Next</span>
              </a>
            </div>
          </div>
          <!-- /.row -->
        </div>
        <!-- /.container -->
      </section>
      <!-- /.about-three -->

      <section class="funfact-one">
        <div class="container">
          <div class="row">
            <div
              class="col-lg-3 col-md-6 col-sm-12 wow fadeInUp"
              data-wow-duration="1500ms"
            >
              <div class="funfact-one__single">
                <div class="funfact-one__counter">
                  <h3><span class="counter">8</span>+</h3>
                </div>
                <!-- /.funfact-one__counter -->
                <p>多年经验</p>
              </div>
              <!-- /.funfact-one__single -->
            </div>
            <!-- /.col-lg-3 -->
            <div
              class="col-lg-3 col-md-6 col-sm-12 wow fadeInUp"
              data-wow-duration="1500ms"
            >
              <div class="funfact-one__single">
                <div class="funfact-one__counter">
                  <h3><span class="counter">750</span></h3>
                </div>
                <!-- /.funfact-one__counter -->
                <p>志愿者</p>
              </div>
              <!-- /.funfact-one__single -->
            </div>
            <!-- /.col-lg-3 -->
            <div
              class="col-lg-3 col-md-6 col-sm-12 wow fadeInUp"
              data-wow-duration="1500ms"
            >
              <div class="funfact-one__single">
                <div class="funfact-one__counter">
                  <h3>
                    <span class="counter">20</span
                    ><!-- /.counter -->k+
                  </h3>
                </div>
                <!-- /.funfact-one__counter -->
                <p>满意的客户</p>
              </div>
              <!-- /.funfact-one__single -->
            </div>
            <!-- /.col-lg-3 -->
            <div
              class="col-lg-3 col-md-6 col-sm-12 wow fadeInUp"
              data-wow-duration="1500ms"
            >
              <div class="funfact-one__single">
                <div class="funfact-one__counter">
                  <h3><span class="counter">30</span>+</h3>
                </div>
                <!-- /.funfact-one__counter -->
                <p>获奖情况</p>
              </div>
              <!-- /.funfact-one__single -->
            </div>
            <!-- /.col-lg-3 -->
          </div>
          <!-- /.row -->
        </div>
        <!-- /.container -->
      </section>
      <!-- /.funfact-one -->

      <section class="faq-three">
        <div class="container">
          <div class="row">
            <div class="col-lg-6">
              <section class="slider-one__wrapper">
                <!-- /.slider-one__nav -->

                <el-carousel
                  indicator-position="outside"
                  :interval="4000"
                  height="500px"
                >
                  <el-carousel-item
                    v-for="(item, index) in carouselimage"
                    :key="index"
                  >
                    <img
                      :src="item"
                      alt="Carousel Image"
                      style="width: 100%; height: 100%; object-fit: cover"
                    />
                  </el-carousel-item>
                </el-carousel>
                <!-- /.slider-one__carousel owl-carousel owl-theme thm__owl-carousel -->
              </section>
              <!-- /.slider-one__wrapper -->
            </div>
            <!-- /.col-lg-6 -->
            <div class="col-lg-6">
              <div class="faq-one__block">
                <div class="block-title text-left">
                  <p class="has-line">为什么选择我们</p>
                  <h3>未来：中国人的老年建筑"九连环"</h3>
                </div>
                <!-- /.block-title -->

                <p>
                  每天的目标是确保我们的需求不仅得到满足，而且得到超越。
                  为了实现这一目标，我们致力于提供
                </p>
                <div
                  class="accrodion-grp"
                  data-grp-name="career-one__accrodion"
                >
                  <div class="accrodion">
                    <div class="accrodion-title">
                      <h4>度假式生活</h4>
                    </div>
                    <div class="accrodion-content">
                      <div class="inner">
                        <p>
                          "区域性养老服务体系"提供商拥有"四位一体"养老服务能力!
                        </p>
                      </div>
                      <!-- /.inner -->
                    </div>
                  </div>
                  <div class="accrodion active">
                    <div class="accrodion-title">
                      <h4>安全保障</h4>
                    </div>
                    <div class="accrodion-content">
                      <div class="inner">
                        <p>
                          "区域性养老服务体系"提供商拥有"四位一体"养老服务能力!
                        </p>
                      </div>
                      <!-- /.inner -->
                    </div>
                  </div>
                  <div class="accrodion">
                    <div class="accrodion-title">
                      <h4>护理人员</h4>
                    </div>
                    <div class="accrodion-content">
                      <div class="inner">
                        <p>
                          "区域性养老服务体系"提供商拥有"四位一体"养老服务能力!
                        </p>
                      </div>
                      <!-- /.inner -->
                    </div>
                  </div>
                </div>
              </div>
              <!-- /.faq-one__block -->
            </div>
            <!-- /.col-lg-6 -->
          </div>
          <!-- /.row -->
        </div>
        <!-- /.container -->
      </section>
      <!-- /.faq-three -->

      <section
        class="testimonials-two"
        :style="{
          backgroundImage: `url(${require('@/assets/images/index/12579998.jpg')})`,
        }"
      >
        <div class="container">
          <div class="row">
            <div class="col-xl-7 col-lg-8">
              <div
                class="testimonials-two__content wow fadeInUp"
                data-wow-duration="1500ms"
              >
                <div class="block-title">
                  <p class="has-line">团队与设施</p>
                  <!-- /.has-line -->
                  <h3>Team and facilities</h3>
                </div>
                <!-- /.block-title -->
                <div class="testimonials-two__carousel">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide">
                      <div class="testimonials-two__single">
                        <h3>
                          "区域性养老服务体系"提供商拥有"四位一体"养老服务能力
                        </h3>
                        <span>Instructor</span>
                      </div>
                      <!-- /.testimonials-two__single -->
                    </div>
                    <!-- /.swiper-slide -->
                    <div class="swiper-slide">
                      <div class="testimonials-two__single">
                        <p>
                          "区域性养老服务体系"提供商拥有"四位一体"养老服务能力
                        </p>
                        <h3>Lina Dean</h3>
                        <span>Instructor</span>
                      </div>
                      <!-- /.testimonials-two__single -->
                    </div>
                    <!-- /.swiper-slide -->
                    <div class="swiper-slide">
                      <div class="testimonials-two__single">
                        <p>
                          "区域性养老服务体系"提供商拥有"四位一体"养老服务能力
                        </p>
                        <h3>Leon Cortez</h3>
                        <span>Instructor</span>
                      </div>
                      <!-- /.testimonials-two__single -->
                    </div>
                    <!-- /.swiper-slide -->
                  </div>
                  <!-- /.swiper-wrapper -->
                </div>
                <!-- /.testimonials-two__carousel -->
                <div class="testimonials-two__thumb-carousel-wrap">
                  <div class="testimonials-two__thumb-carousel">
                    <div class="swiper-wrapper">
                      <div class="swiper-slide">
                        <img
                          src="@/assets/images/index/26550531.jpg"
                          alt=""
                          style="width: 80px; height: 80px"
                        />
                      </div>
                      <!-- /.swiper-slide -->
                      <div class="swiper-slide">
                        <img
                          src="@/assets/images/index/12579997.jpg"
                          style="width: 80px; height: 80px"
                          alt=""
                        />
                      </div>
                      <!-- /.swiper-slide -->
                      <div class="swiper-slide">
                        <img
                          src="@/assets/images/index/26550535.jpg"
                          style="width: 80px; height: 80px"
                          alt=""
                        />
                      </div>
                      <!-- /.swiper-slide -->
                    </div>
                    <!-- /.swiper-wrapper -->
                  </div>
                  <!-- /.testimonials-two__thumb-carousel -->
                </div>
                <!-- /.testimonials-two__carousel-wrap -->
              </div>
              <!-- /.testimonials-two__content -->
            </div>
            <!-- /.col-lg-7 -->
          </div>
          <!-- /.row -->
        </div>
        <!-- /.container -->
      </section>
      <!-- /.testimonials-two -->

      <section class="blog-one">
        <div class="container">
          <div class="block-title text-center">
            <p>新闻动态</p>
            <!-- <h3>News</h3> -->
          </div>
          <!-- /.block-title -->
          <div class="row">
            <div
              class="col-lg-4"
              v-for="article in articles.slice(0, 3)"
              :key="article.articleId"
            >
              <div class="blog-one__single">
                <!-- 使用 @click 监听点击事件 -->
                <a @click.prevent="openArticle(article.articleId)">
                  <div class="blog-one__image">
                    <img
                      :src="article.featuredImage"
                      :alt="article.articleTitle"
                    />
                  </div>
                  <!-- /.blog-one__image -->
                </a>

                <div class="blog-one__content">
                  <h3>
                    <a @click.prevent="openArticle(article.articleId)">
                      {{ article.articleTitle }}
                    </a>
                  </h3>
                  <ul class="blog-one__meta list-unstyled">
                    <li>
                      <a>{{ article.articleAuthor }}</a>
                    </li>
                    <li>
                      <a>{{ article.publishedTime.split(' ')[0]}}</a>
                    </li>
                  </ul>
                  <!-- /.blog-one__meta -->
                  <a class="blog-one__link">
                    <i class="far fa-long-arrow-alt-right"></i>
                  </a>
                  <!-- /.blog-one__link -->
                </div>
                <!-- /.blog-one__content -->
              </div>
              <!-- /.blog-one__single -->
            </div>
            <!-- /.col-lg-4 -->
          </div>
          <!-- /.row -->
        </div>
        <!-- /.container -->
      </section>
      <!-- /.blog-one -->
      <section class="event-two">
        <div class="container">
          <div class="block-title text-center">
            <p>多彩活动</p>
            <h3>Colorful activities</h3>
          </div>
          <!-- /.block-title -->
          <div class="row no-gutters">
            <div class="col-xl-6">
              <div class="event-two__single">
                <div class="event-two__image">
                  <img src="@/assets/images/index/12600339.jpg" alt="" />
                </div>
                <!-- /.event-two__image -->
                <div class="event-two__content d-flex">
                  <div class="my-auto">
                    <div class="event-two__date">
                      <b>25</b> <span>Mar</span>
                    </div>
                    <!-- /.event-two__date -->
                    <h3><a>为更美好的明天而努力</a></h3>
                    <!-- <p>每天的目标是确保我们的需求得到满足.</p> -->
                  </div>
                  <!-- /.my-auto -->
                </div>
                <!-- /.event-two__content -->
              </div>
              <!-- /.event-two__single -->
            </div>
            <!-- /.col-lg-6 -->
            <div class="col-xl-6">
              <div class="event-two__single">
                <div class="event-two__image">
                  <img src="@/assets/images/index/12600345.jpg" alt="" />
                </div>
                <!-- /.event-two__image -->
                <div class="event-two__content d-flex">
                  <div class="my-auto">
                    <div class="event-two__date">
                      <b>25</b> <span>Mar</span>
                    </div>
                    <!-- /.event-two__date -->
                    <h3><a>为更美好的明天而努力</a></h3>
                    <!-- <p>每天的目标是确保我们的需求得到满足</p> -->
                  </div>
                  <!-- /.my-auto -->
                </div>
                <!-- /.event-two__content -->
              </div>
              <!-- /.event-two__single -->
            </div>
            <!-- /.col-lg-6 -->
            <div class="col-xl-6">
              <div class="event-two__single">
                <div class="event-two__image">
                  <!-- <img src="assets/images/event/event-2-3.jpg" alt=""> -->
                  <img src="@/assets/images/index/12600343.jpg" alt="" />
                </div>
                <!-- /.event-two__image -->
                <div class="event-two__content d-flex">
                  <div class="my-auto">
                    <div class="event-two__date">
                      <b>25</b> <span>Mar</span>
                    </div>
                    <!-- /.event-two__date -->
                    <h3><a>为更美好的明天而努力</a></h3>

                    <!-- <p>每天的目标是确保我们的需求得到满足.</p> -->
                  </div>
                  <!-- /.my-auto -->
                </div>
                <!-- /.event-two__content -->
              </div>
              <!-- /.event-two__single -->
            </div>
            <!-- /.col-lg-6 -->
            <div class="col-xl-6">
              <div class="event-two__single">
                <div class="event-two__image">
                  <!-- <img src="assets/images/event/event-2-4.jpg" alt=""> -->
                  <img src="@/assets/images/index/12600342.jpg" alt="" />
                </div>
                <!-- /.event-two__image -->
                <div class="event-two__content d-flex">
                  <div class="my-auto">
                    <div class="event-two__date">
                      <b>25</b> <span>Mar</span>
                    </div>
                    <!-- /.event-two__date -->
                    <h3><a>为更美好的明天而努力</a></h3>

                    <!-- <p>每天的目标是确保我们的需求得到满足.</p> -->
                  </div>
                  <!-- /.my-auto -->
                </div>
                <!-- /.event-two__content -->
              </div>
              <!-- /.event-two__single -->
            </div>
            <!-- /.col-lg-6 -->
          </div>
          <!-- /.row -->
        </div>
        <!-- /.container -->
      </section>
      <!-- /.event-two -->
      <!-- 联系表单区域 -->
      <section class="appointment-one appointment-one__home-one">
        <div class="appointment-one__moc">
          <p v-for="(info, index) in contactInfo" :key="index">{{ info }}</p>
          <div>
            <img
              v-for="(qr, index) in qrCodes"
              :key="index"
              :src="qr"
              style="width: 150px; height: 150px"
              alt="二维码"
            />
          </div>
        </div>

        <div class="container">
          <div class="row justify-content-end">
            <div class="col-lg-6">
              <div class="block-title text-left">
                <p class="has-line">联系我们</p>
                <h3>想了解更多关于<br />长养乐园养老院的信息吗?</h3>
              </div>

              <form
                @submit.prevent="handleSubmit"
                class="contact-one__form contact-form-validated"
              >
                <div class="row">
                  <div class="col-md-6">
                    <input
                      type="text"
                      v-model="formData.name"
                      placeholder="姓名"
                      name="name"
                    />
                  </div>
                  <div class="col-md-6">
                    <input
                      type="email"
                      v-model="formData.email"
                      placeholder="邮箱"
                      name="email"
                    />
                  </div>
                  <div class="col-md-6">
                    <input
                      type="tel"
                      v-model="formData.phone"
                      placeholder="手机号"
                      name="phone"
                    />
                  </div>
                  <div class="col-md-12">
                    <textarea
                      v-model="formData.message"
                      name="message"
                      placeholder="消息"
                    ></textarea>
                  </div>
                  <div class="col-md-12 text-left">
                    <button type="submit" class="thm-btn contact-one__btn">
                      立即提交
                    </button>
                  </div>
                </div>
              </form>
              <div class="result"></div>
            </div>
          </div>
        </div>
      </section>
      <!-- /.appointment-one -->
    </div>
    <!-- /.page-wrapper -->

    <a href="#" data-target="html" class="scroll-to-target scroll-to-top"
      ><i class="fa fa-angle-up"></i
    ></a>

    <!-- 侧边栏菜单 -->
    <div class="side-menu__block" :class="{ active: sideMenuOpen }">
      <a
        href="#"
        class="side-menu__toggler side-menu__close-btn"
        @click.prevent="toggleSideMenu"
      >
        <i class="fa fa-times"></i>
      </a>

      <div class="side-menu__block-overlay" @click="toggleSideMenu">
      </div>

      <div class="side-menu__block-inner">
        <router-link to="/" class="side-menu__logo">
          <img src="@/assets/images/index/1257939.png" alt="Logo" width="190" />
        </router-link>

        <nav class="mobile-nav__container">
          <!-- content is loading via js -->
          <ul class="main-nav__navigation-box">
            <li
              class="dropdown"
              v-for="(item, index) in menuItems"
              :key="index"
            >
              <router-link :to="item.path">{{ item.name }}</router-link>
            </li>
          </ul>
        </nav>
      </div>
    </div>
    <!-- /.side-menu__block -->
  </div>
</template>
<script>
import "@/assets/js/jquery.min.js";
import "@/assets/js/bootstrap.bundle.min.js";
import "@/assets/js/bootstrap-datepicker.min.js";
import "@/assets/js/bootstrap-select.min.js";
import "@/assets/js/isotope.js";
import { articleApi } from "@/api/modules/article";
import MenuItem from "@/components/MenuItem.vue";

export default {
  name: 'Index',
  components: {
    MenuItem
  },
  data() {
    return {
      menuItems: [
        { name: "首页", path: "/" },
        { name: "关于我们", path: "/about" },
        { name: "入住指南", path: "/checkinguide" },
        { name: "医养结合", path: "/blog" },
        { name: "新闻中心", path: "/event" },
        { name: "联系我们", path: "/contact" },
        { name: '产品展示', path: '/productshow' },
      ],
      backgroundStyle: {
        backgroundImage: `url(${require("@/assets/images/index/index1.jpg")})`,
      },
      carouselimages: [
        require("@/assets/images/index/index1.jpg"),
        require("@/assets/images/index/index2.jpg"),
      ],
      carouselimage: [
        require("@/assets/images/index/12580156.jpg"),
        require("@/assets/images/index/12579997.jpg"),
      ],
      rowList: this.loadJinqiImages(),
      videos: [require("@/assets/images/index/video.mp4")],
      contactInfo: [
        "公司:海南长养乐园养老服务有限公司",
        "地址:海南省琼海市嘉积镇上埇嘉昌街5号",
        "电话:400-889-0919",
        "传真:0898-36836706",
        "邮箱:756621398@qq.com",
        "手机:13976607717",
      ],
      qrCodes: [
        require("@/assets/images/index/13171515.jpg"),
        require("@/assets/images/index/13171515.jpg"),
      ],
      formData: {
        name: "",
        email: "",
        phone: "",
        message: "",
      },
      articles: [],
      showScrollTop: false,
      sideMenuOpen: false,
    };
  },
  async mounted() {
    try {
      const columnId = '1885570362373574658';
      const res = await articleApi.getList({ columnId });
      this.articles = res.rows;
    } catch (error) {
      console.error("Error fetching news:", error);
    }

    window.addEventListener('scroll', this.handleScroll);
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    async openArticle(articleId) {
      try {
        const response = await articleApi.getListDetails(articleId);
        const articleDetails = response.data;
        this.$router.push(`/event-details/${articleDetails.articleId}`);
        console.log(articleDetails);
      } catch (error) {
        console.error('Failed to fetch article details:', error);
      }
    },
    formatDate(date) {
      return date.split('T')[0];
    },
    toggleSideMenu() {
      this.sideMenuOpen = !this.sideMenuOpen;
    },
    async handleSubmit() {
      try {
        console.log("表单数据:", this.formData);
        const res = await articleApi.userConsultations(this.formData);
        if (res.code == 200) {
          this.$message({
            message: "提交成功",
            type: "success",
          });
          this.formData = {
            name: '',
            email: '',
            phone: '',
            message: ''
          };
        }
      } catch (error) {
        this.$message({
          message: "提交失败，请稍后重试",
          type: "error",
        });
      }
    },
    handleScroll() {
      this.showScrollTop = window.scrollY > 100;
    },
    loadJinqiImages() {
      const context = require.context(
        '@/assets/images/jinqi', // 图片目录
        false, // 是否遍历子目录
        /\.(png|jpe?g|gif|svg)$/ // 匹配的文件类型
      );
      
      return context.keys().map(context);
    },
  },
};
</script>
   <style>
@import url("https://fonts.googleapis.com/css?family=Baloo+2:400,500,600,700,800%7CLato:100,300,400,700,900%7COpen+Sans:300,400,600,700,800%7CRoboto:300,400,500,700,900%7CRubik:300,400,500,700,900&display=swap");
@import "@/assets/css/animate.css";
@import "@/assets/css/bootstrap.min.css";
@import "@/assets/css/bootstrap-datepicker.min.css";
@import "@/assets/css/bootstrap-select.min.css";
@import "@/assets/css/fontawesome-all.min.css";
@import "@/assets/css/hover-min.css";
@import "@/assets/css/swiper.min.css";
@import "@/assets/css/jquery.mCustomScrollbar.min.css";
@import "@/assets/css/magnific-popup.css";
/* @import '@/assets/css/owl.carousel.min.css'; */
@import "@/assets/css/owl.theme.default.min.css";
@import "@/assets/css/oberlin-icons.css";
@import "@/assets/css/style.css";
@import "@/assets/css/responsive.css";
.carousel-item {
  transition: none !important;
}
.carousel-inner img {
  object-fit: cover;
  height: 300px; /* 根据需要调整高度 */
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
</style>